export enum PaymentMethod {
  BILL_PAY = 'Bill Pay',
  EFT = 'EFT',
  FIAT_PAYOUT = 'Fiat Payout',
  FIAT_OTHER = 'Fiat Payout Other Bank',
  CRYPTO_TRANSFER = 'On-chain Transfer'
}
